
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDoesActorHaveInflightRevisionForVconnRequestParams {
  id: string;
}

export interface IDoesActorHaveInflightRevisionForVconnResult extends IResult {
  inflightRevisionExists: boolean;
}

export class DoesActorHaveInflightRevisionForVconnRequest extends Request<IDoesActorHaveInflightRevisionForVconnRequestParams, IDoesActorHaveInflightRevisionForVconnResult> {
  constructor(params: IDoesActorHaveInflightRevisionForVconnRequestParams) {
    super('doesActorHaveInflightRevisionForVConn', params);
  }
}
